












import Vue, {VueConstructor} from 'vue'
import activeInfoBlock from './ActiveInfoBlock.vue'
import {ActiveInfoPageConfig, Sizes} from '@/components/Ui/ActiveInfoPage/BZCore/ActiveInfoPage'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    container: HTMLElement
  }
}>).extend({
  props: {
    scope: {},
    config: {
      type: Object as () => ActiveInfoPageConfig
    }
  },
  data () {
    return {
      width: 0 as number
    }
  },
  components: {
    activeInfoBlock
  },
  methods: {
    onResize (element: HTMLElement): void {
      this.width = element.clientWidth;
    },
    getSizePrefix (width: number): string {
      let prefix: string = '';
      for (const size in Sizes) {
        if (!prefix) {
          prefix = size
          continue;
        }
        if (width >= Sizes[size]) {
          prefix = size;
        }
      }
      return prefix;
    },
    getMapColumnKeyName (): string {
      let prefix: string = ''
      for (let size of Object.keys(this.config.mapsColumns)) {
        if (!prefix) {
          prefix = size
          continue;
        }

        if (Sizes[size] >= Sizes[this.sizePrefix]) {
          prefix = size
        }
      }
      return prefix;
    },
  },
  computed: {
    sizePrefix (): string {
      return this.getSizePrefix(this.width)
    },
    mapColumn (): string[][] {
      return this.config.mapsColumns[this.getMapColumnKeyName()]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.width = this.$refs.container.clientWidth
    });
  }
})
